import { mdiDeleteOutline, mdiPencilOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListS from '../../Components/UI/ListS/ListS';
import useHttp from '../../hooks/http';
import { showError } from '../../store';

const tart = ['first_name', 'last_name', 'username', 'group'];
const wido = ['100%', '100%', '100%', '100%'];

const Users = () => {
  const [users, setUsers] = useState();
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);
      const the = [];
      data.forEach((e) => {
        const temp = [];
        tart.forEach((element) => {
          temp.push(e[element]);
        });
        the.push(temp);
      });
      setUsers(the);
      console.log(the);

      clear();
    }
  }, [error, isLoading, data, clear, setMessage]);

  useEffect(() => {
    sendRequest('get/users', 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token]);

  return (
    <ListS>
      {users &&
        users.map((e, i) => (
          <ul key={`e-${i}`}>
            {e.map((element, index) => (
              <li style={{ width: wido[index] }} key={`element-${index}`}>
                {element}
              </li>
            ))}
            <li className='edit'>
              <Icon path={mdiPencilOutline} />
            </li>
            <li className='trash'>
              <Icon path={mdiDeleteOutline} />
            </li>
          </ul>
        ))}
    </ListS>
  );
};

export default Users;
